import { createReducer } from 'typesafe-actions';

import {
  setThemeSpotlightVisited,
  setThemeSpotlightExpired,
  setNodeLunchSpotlightVisited,
  setNodeLunchSpotlightExpired,
  setNodeLunchSpotlightIgnored,
} from './actions';
import { isExpired } from '../utils';

export type StateKey = 'theme' | 'nodeLunch';

export type StateValue = {
  visited: boolean;
  expired: boolean;
  ignored?: boolean;
};

export type State = Record<StateKey, StateValue>;

const initialState: State = {
  theme: {
    visited: false,
    expired: true,
  },
  nodeLunch: {
    visited: false,
    expired: false,
    ignored: true,
  },
};

export default createReducer(initialState)
  .handleAction(
    setThemeSpotlightExpired,
    (state): State => ({
      ...state,
      theme: {
        ...state.theme,
        expired: isExpired({
          buildDate: config.spotlight_theme_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightExpired,
    (state): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        expired: isExpired({
          buildDate: config.spotlight_node_lunch_release_date,
          durationDays: config.spotlight_duration_days,
        }),
      },
    })
  )
  .handleAction(
    setThemeSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      theme: {
        ...state.theme,
        visited: payload,
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightVisited,
    (state, { payload }): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        visited: payload,
      },
    })
  )
  .handleAction(
    setNodeLunchSpotlightIgnored,
    (state, { payload }): State => ({
      ...state,
      nodeLunch: {
        ...state.nodeLunch,
        ignored: payload,
      },
    })
  );
